import React from "react"

function ImageComponent(props: any) {
  return (
    <div className=" flex w-full justify-center">
      <img
        src={props.image?.filename}
        className="w-full !mb-0"
        alt={props.alt}
      />
    </div>
  )
}

export default ImageComponent
